import { render, staticRenderFns } from "./NewProduct.vue?vue&type=template&id=7d8d2346&scoped=true"
import script from "./NewProduct.vue?vue&type=script&lang=js"
export * from "./NewProduct.vue?vue&type=script&lang=js"
import style0 from "./NewProduct.vue?vue&type=style&index=0&id=7d8d2346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d2346",
  null
  
)

export default component.exports